import { publish, subscribe } from './EventCallback';

export interface PanelFavoritesState {
    profileId: string | null;
    favorites: Record<string, boolean>;
    dirty: boolean;
}

let requestCounter = 0;

/**
 * Asks the panel window for its live favorite state. Stays platform-agnostic: it publishes
 * `requestPanelFavorites` on the local event bus and awaits `panelFavoritesResponse`; the desktop
 * layer bridges those bus events to/from IPC. Resolves with empty/not-dirty state if the panel does
 * not answer within `timeoutMs` (e.g. the panel window isn't open).
 */
export function requestPanelFavorites(timeoutMs = 2000): Promise<PanelFavoritesState> {
    const requestId = `panel-favorites-${++requestCounter}`;
    return new Promise<PanelFavoritesState>((resolve) => {
        let settled = false;
        const finish = (state: PanelFavoritesState) => {
            if (settled) return;
            settled = true;
            unsubscribe();
            clearTimeout(timer);
            resolve(state);
        };

        const unsubscribe = subscribe('panelFavoritesResponse', (data) => {
            if (data.requestId !== requestId) return;
            finish({ profileId: data.profileId, favorites: data.favorites, dirty: data.dirty });
        });

        const timer = setTimeout(() => finish({ profileId: null, favorites: {}, dirty: false }), timeoutMs);

        publish('requestPanelFavorites', { requestId });
    });
}
